// extracted by mini-css-extract-plugin
export default {"wrapper":"FuwFiles_wrapper__rPco7"};